import React from 'react';
import { CTAButton } from './CTAButton';
import { AUTHOR_PHOTO } from '../data/content';
export function AboutAuthor() {
  return <section className="w-full bg-white px-4 py-14 sm:px-6 sm:py-20" data-id="element-21" data-mp="1e9fp97cimy7h">
      <div className="mx-auto max-w-5xl" data-id="element-22" data-mp="1sz4rz709ba9v">
        <h2 className="text-center font-display text-[26px] font-bold leading-tight text-ink sm:text-4xl" data-id="element-23" data-mp="1sy20oxz0v5tf">
          🦷 Why The Natural Veneer Blueprint™ was created
        </h2>

        <div className="mt-9 grid grid-cols-1 gap-7 lg:grid-cols-[minmax(0,300px)_minmax(0,1fr)] lg:items-start lg:gap-10" data-id="element-24" data-mp="10az9ys0l7zdq">
          <figure className="mx-auto w-full max-w-[280px] lg:max-w-none" data-id="element-25" data-mp="vd7hnww16b90">
            <img src={AUTHOR_PHOTO} alt="Dra. Karito, dentist and creator of The Natural Veneer Blueprint" className="w-full rounded-3xl object-cover" width={944} height={1568} loading="lazy" data-id="element-26" data-mp="19cfieu7udrfb" />
            <figcaption className="mt-3 text-center" data-id="element-27" data-mp="2gno09mjb3n1y">
              <span className="block font-display text-lg font-bold text-ink" data-id="element-28" data-mp="2wk0hbvgfnja9">Dra. Karito</span>
              <span className="mt-0.5 block text-[12.5px] font-semibold uppercase tracking-[0.1em] text-brand-600" data-id="element-29" data-mp="31j3aahj51z1v">
                Dentist · Creator of the Blueprint™
              </span>
            </figcaption>
          </figure>

          <div className="space-y-4 text-[15px] leading-relaxed text-brand-900/75" data-id="element-30" data-mp="3ak1jde8fowrb">
            <p data-id="element-31" data-mp="2du2afiodfw87">
              For years, dentists have learned resin veneers by accumulating techniques, courses,
              materials, brands, and different layering approaches.
            </p>
            <p className="font-display text-xl font-bold text-ink sm:text-2xl" data-id="element-32" data-mp="2mtp23cratno2">
              But there’s a problem: more information doesn’t automatically mean better decisions.
            </p>
            <p data-id="element-33" data-mp="1u5tagmgl6ly5">
              You can watch dozens of veneer demonstrations and still find yourself asking:{' '}
              <em className="font-semibold text-brand-700" data-id="element-34" data-mp="1z3uqszmmo75x">“Why doesn’t mine look like that?”</em>
            </p>
            <div className="rounded-2xl border-l-4 border-brand-600 bg-brand-50 px-5 py-4" data-id="element-35" data-mp="32eichcbb63wi">
              <p className="text-[15px] font-semibold leading-relaxed text-brand-800" data-id="element-36" data-mp="2xfe2wkkh245n">
                The Natural Veneer Blueprint™ was created around one simple idea: before you can
                consistently create a more natural-looking veneer, you need to understand what makes
                a veneer look natural in the first place.
              </p>
            </div>
            <p data-id="element-37" data-mp="2ei4hwyzi0ima">
              That’s why this isn’t designed as another endless video course. It’s designed as a{' '}
              <strong className="font-bold text-ink" data-id="element-38" data-mp="2sif9y5cjo391">visual analysis and reference system</strong> —
              a practical framework that organizes the key variables into maps, decisions,
              checklists, and visual references you can return to whenever you need them.
            </p>
          </div>
        </div>

        <div className="mx-auto mt-10 max-w-xl" data-id="element-39" data-mp="2rilrou1va7k">
          <CTAButton label="Get the visual reference system" note="$27 USD one-time · Instant access · 7-day guarantee" data-id="element-40" data-mp="b9auhajwd36u" />
        </div>
      </div>
    </section>;
}